// extracted by mini-css-extract-plugin
export default {"highLights":"style_highLights__06eJm","content":"style_content__cQzXM","item":"style_item__ucZt6"};